/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { DeviceModel } from '../../../core/device';
import { MousetrapProps } from './MousetrapProps';

import './Mousetrap.scss';

const Mousetrap: FunctionComponent<MousetrapProps> = ({
    children,
    value,
    className,
    style,
}): JSX.Element => {
    const mousetrapClasses = `${DeviceModel.isWebOsPlatform() ? 'mousetrap' : ''}${
        className ? ` ${className}` : ''
    }`;

    return (
        <React.Fragment>
            <div className={mousetrapClasses} data-value={value} style={style}>
                {children}
            </div>
        </React.Fragment>
    );
};

Mousetrap.propTypes = {
    children: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default Mousetrap;
